<template lang="pug">
  transition(name="fade")
    .loading-overlay(v-if="visible")
      img(:src="gifSrcWithTs" :key="gifKey" alt="Loading...")
</template>

<script>
import loadingGif from '@/assets/img/icon/loading.gif' // 透過打包器處理資產

export default {
  name: 'LoadingOverlay',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gifKey: 0
    }
  },
  computed: {
    gifSrcWithTs() {
      // 加上遞增的時間戳，避免瀏覽器使用快取的幀狀態
      return `${loadingGif}?t=${this.gifKey}`
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 每次顯示時遞增 key，迫使 <img> 重新掛載並重播
        this.gifKey++
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  /* z-index: 9999; */
  z-index: 10000;
}
.loading-overlay img {
  width: 200px;
  height: 200px;
  position: relative;
  z-index: 1;
}
</style>